import { useState } from "react";
import { Button, Icon } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import {
    isPendingBannerDismissed,
    rememberPendingBannerDismissed,
} from "../_helpers/pendingBannerDismissal";

interface PendingClientsBannerProps {
    // Clients with at least one pending location, before any filter. Nothing
    // renders while it is 0 or absent.
    count: number | undefined;
    onReview: () => void;
}

// X2 (2026-10-27), as Clients.png draws it, in the page's title row. The
// top-bar Clients badge (PendingClientsBadge) stays too: X2 keeps both. The
// banner brings its own grid cell, so a hidden banner leaves no empty row.
export const PendingClientsBanner = ({
    count,
    onReview,
}: PendingClientsBannerProps) => {
    const [dismissed, setDismissed] = useState(isPendingBannerDismissed);

    if (!count || dismissed) {
        return null;
    }

    const handleDismiss = () => {
        rememberPendingBannerDismissed();
        setDismissed(true);
    };

    return (
        <div className="col-span-12 lg:col-span-6 lg:justify-self-center">
            <div
                role="status"
                className="alert alert-warning w-fit py-2 shadow-md text-neutral"
            >
                <Icon name="info" />
                <span className="font-bold">
                    {count === 1
                        ? "1 Pending client needs to be reviewed."
                        : `${count} Pending clients need to be reviewed.`}
                </span>
                <div className="flex gap-2">
                    <Button
                        size={ComponentSize.XS}
                        color={ComponentColor.Ghost}
                        className="bg-base-100 text-neutral"
                        onClick={handleDismiss}
                    >
                        Dismiss
                    </Button>
                    <Button
                        size={ComponentSize.XS}
                        color={ComponentColor.Secondary}
                        onClick={onReview}
                    >
                        Review
                    </Button>
                </div>
            </div>
        </div>
    );
};
